var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResidentAutoPayments',{staticClass:"height-100",attrs:{"minHeight":"calc(100vh - 430px)","maxHeight":"calc(100vh - 430px)","resident":Number(_vm.residentId)}})}
var staticRenderFns = []

export { render, staticRenderFns }